export const SET_DEVICE_HEIGHT_WIDTH = "@device/SET_DEVICE_HEIGHT_WIDTH";
export const SET_DEVICE_DETAILS = "@device/SET_DEVICE_DETAILS";
export const SET_SIDE_BAR = "@device/SET_SIDE_BAR";

export const SET_SET_VISIBLE = "@device/SET_SET_VISIBLE";
export const SET_SIDEBAR_HIDE = "@device/SET_SIDEBAR_HIDE";

export const SET_MY_AC_SIDE_BAR_VISIBLE = "@device/SET_MY_AC_SIDE_BAR_VISIBLE";
export const SET_MY_AC_SIDEBAR_HIDE = "@device/SET_MY_AC_SIDEBAR_HIDE";

export const SET_ADD_STAFF_VISIBLE = "@device/SET_ADD_STAFF_VISIBLE";
export const SET_ADD_STAFF_SIDEBAR_HIDE = "@device/SET_ADD_STAFF_SIDEBAR_HIDE";

